<template>
  <router-view />
</template>

<script>
export default {
  name: 'App',
  data: () => ({
    //
  })
}
</script>

<style>
    body {
        height: 100%;
    }
</style>
